export default __webpack_public_path__ + "static/media/brimstone-haunt-logo_textured-2020.5cdd470a.png";